import service from '../service/colleaguesBuyShare'
import CONSTANT from '../constant/colleaguesBuyShare'
import _ from 'underscore'
import { Indicator } from 'mint-ui';
export default {
    getColleaguesBuyShareInfo({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getColleaguesBuyShareInfo(data).then(result => {
                resolve(result)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GETGROUPINFO_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GETGROUPINFO_ERROR, e)
                // commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getColleaguesBuyProductList({ commit }, data) {
        Indicator.open();
        return new Promise((resolve, reject) => {
            return service.getColleaguesBuyProductList(data).then(result => {
                resolve(result)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GETPRODUCTLIST_SUCCESS, result)
                Indicator.close();
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GETPRODUCTLIST_ERROR, e)
                // commit('rootApperError', e)
                Indicator.close();
            })
        })
    },
    getCommunityList({ commit }) {
        return new Promise((resolve, reject) => {
            return service.getCommunityList().then(result => {
                resolve(result)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_SUCCESS, result)
                return result
            }, e => {
                reject(e)
                commit(CONSTANT.COLLEAGUESBUYSHARE_GET_COMMUNITY_LIST_ERROR, e)
            })
        })
    }
}